export default __webpack_public_path__ + "static/contact-blue-bg-6b2a9e8e0740a3fd19c11cc6cca13d54.jpg";